<template>
  <div class="h-full w-full flex flex-col p-8 text-left">
    <div v-if="role != 'partner' && mode == 'create'" class="flex flex-col mb-6">
      <div class="grid grid-cols-2 gap-6">
        <div class="flex flex-col">
          <div class="flex flex-col" :class="{ invalid: !employerType.isValid }">
            <label for="employerType" class="flex-shrink-0">
              Employer Type*
            </label>
            <select class="ht-42" v-model.trim="employerType.val" @change="clearValidity('employerType')"
              id="employerType">
              <option value="registered">Registered Employer</option>
              <option value="non_registered">Non - Registered Employer</option>
            </select>
          </div>
          <transition name="fade" mode="out-in">
            <p v-if="!employerType.isValid" class="h-4 text-xs text-red-600">
              {{ employerType.msg }}
            </p>
          </transition>
        </div>
        <div v-if="employerType.val == 'registered'" class="flex flex-col">
          <div class="flex flex-col" :class="{ invalid: !selectedEmployer.isValid }">
            <label for="selectedEmployer" class="flex-shrink-0">
              Employer*
            </label>
            <multiselect v-model.trim="selectedEmployer.val" :options="partnersList" track-by="id"
              :custom-label="customLabelForRegisteredEmployer" placeholder="Select an Employer">
            </multiselect>
          </div>
          <transition name="fade" mode="out-in">
            <p v-if="!selectedEmployer.isValid" class="h-4 text-xs text-red-600">
              {{ selectedEmployer.msg }}
            </p>
          </transition>
        </div>
        <div v-else class="flex flex-col">
          <div class="flex flex-col" :class="{ invalid: !nonRegisteredEmployer.isValid }">
            <label for="nonRegisteredEmployer" class="flex-shrink-0">
              Employer*
            </label>
            <multiselect v-model.trim="nonRegisteredEmployer.val" :options="nonRegisteredEmployersList"
              placeholder="Select an Employer">
            </multiselect>
            <input v-if="nonRegisteredEmployer.val == 'Other'" class="mt-2" type="text" id="nonRegisteredEmployerOther"
              v-model.trim="nonRegisteredEmployerOther" placeholder="Enter Employer Name"
              @blur="clearValidity('nonRegisteredEmployer')" />
          </div>
          <transition name="fade" mode="out-in">
            <p v-if="!nonRegisteredEmployer.isValid" class="h-4 text-xs text-red-600">
              {{ nonRegisteredEmployer.msg }}
            </p>
          </transition>
        </div>
      </div>
    </div>
    <div class="grid grid-cols-3 gap-6">
      <div class="flex flex-col" :class="{ invalid: !jobTitle.isValid }">
        <label for="jobTitle">Job Title*</label>
        <input type="text" id="jobTitle" v-model.trim="jobTitle.val" placeholder="" @blur="clearValidity('jobTitle')" />
        <transition name="fade" mode="out-in">
          <p v-if="!jobTitle.isValid" class="h-4 text-xs text-red-600">
            {{ jobTitle.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !positionName.isValid }">
        <label for="positionName">Position*</label>
        <input type="text" id="positionName" v-model.trim="positionName.val" placeholder=""
          @blur="clearValidity('positionName')" />
        <transition name="fade" mode="out-in">
          <p v-if="!positionName.isValid" class="h-4 text-xs text-red-600">
            {{ positionName.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !positionNumber.isValid }">
        <label for="positionNumber">Position Code</label>
        <input type="text" id="positionNumber" v-model.trim="positionNumber.val" placeholder="602065"
          @blur="clearValidity('positionNumber')" @keypress="allowNumbersOnly" />
        <transition name="fade" mode="out-in">
          <p v-if="!positionNumber.isValid" class="h-4 text-xs text-red-600">
            {{ positionNumber.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !gradeNumber.isValid }">
        <label for="gradeNumber">Grade Number</label>
        <input type="text" id="gradeNumber" v-model.trim="gradeNumber.val" placeholder=""
          @blur="clearValidity('gradeNumber')" />
        <transition name="fade" mode="out-in">
          <p v-if="!gradeNumber.isValid" class="h-4 text-xs text-red-600">
            {{ gradeNumber.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !minimumQualification.isValid }">
        <label for="minimumQualification">Minimum Qualification</label>
        <input type="text" id="minimumQualification" v-model.trim="minimumQualification.val" placeholder=""
          @blur="clearValidity('minimumQualification')" />
        <transition name="fade" mode="out-in">
          <p v-if="!minimumQualification.isValid" class="h-4 text-xs text-red-600">
            {{ minimumQualification.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !preferredQualification.isValid }">
        <label for="preferredQualification">Preferred Qualification</label>
        <input type="text" id="preferredQualification" v-model.trim="preferredQualification.val" placeholder=""
          @blur="clearValidity('preferredQualification')" />
        <transition name="fade" mode="out-in">
          <p v-if="!preferredQualification.isValid" class="h-4 text-xs text-red-600">
            {{ preferredQualification.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !division.isValid }">
        <label for="division">Division</label>
        <input type="text" id="division" v-model.trim="division.val" placeholder="" @blur="clearValidity('division')" />
        <transition name="fade" mode="out-in">
          <p v-if="!division.isValid" class="h-4 text-xs text-red-600">
            {{ division.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !department.isValid }">
        <label for="department">Department</label>
        <input type="text" id="department" v-model.trim="department.val" placeholder=""
          @blur="clearValidity('department')" />
        <transition name="fade" mode="out-in">
          <p v-if="!department.isValid" class="h-4 text-xs text-red-600">
            {{ department.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !jobStartDate.isValid }">
        <label for="jobStartDate">Job Offer Start Date*</label>
        <input type="date" id="jobStartDate" v-model.trim="jobStartDate.val" placeholder=""
          @blur="clearValidity('jobStartDate')" />
        <transition name="fade" mode="out-in">
          <p v-if="!jobStartDate.isValid" class="h-4 text-xs text-red-600">
            {{ jobStartDate.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !jobCloseDate.isValid }">
        <label for="jobCloseDate">Job Offer Close Date*</label>
        <input type="date" id="jobCloseDate" v-model.trim="jobCloseDate.val" placeholder=""
          @blur="clearValidity('jobCloseDate')" />
        <transition name="fade" mode="out-in">
          <p v-if="!jobCloseDate.isValid" class="h-4 text-xs text-red-600">
            {{ jobCloseDate.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !jobCategory.isValid }">
        <label for="jobCategory">Job Category</label>
        <input type="text" id="jobCategory" v-model.trim="jobCategory.val" placeholder=""
          @blur="clearValidity('jobCategory')" />
        <transition name="fade" mode="out-in">
          <p v-if="!jobCategory.isValid" class="h-4 text-xs text-red-600">
            {{ jobCategory.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !salary.isValid }">
        <label for="salary">Salary Range</label>
        <input type="text" id="salary" v-model.trim="salary.val" placeholder="" @blur="clearValidity('salary')" />
        <transition name="fade" mode="out-in">
          <p v-if="!salary.isValid" class="h-4 text-xs text-red-600">
            {{ salary.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !vacancy.isValid }">
        <label for="vacancy">Vacancy*</label>
        <input type="text" id="vacancy" v-model.trim="vacancy.val" placeholder="7" @blur="clearValidity('vacancy')"
          @keypress="allowNumbersOnly" />
        <transition name="fade" mode="out-in">
          <p v-if="!vacancy.isValid" class="h-4 text-xs text-red-600">
            {{ vacancy.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !expectedSkills.isValid }">
        <label for="expectedSkills">Expected Skills</label>
        <input type="text" id="expectedSkills" v-model.trim="expectedSkills.val" placeholder=""
          @blur="clearValidity('expectedSkills')" />
        <transition name="fade" mode="out-in">
          <p v-if="!expectedSkills.isValid" class="h-4 text-xs text-red-600">
            {{ expectedSkills.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col">
        <label for="benefits">Benefits</label>
        <input type="text" id="benefits" v-model.trim="benefits.val" placeholder="" />
      </div>
      <div class="flex flex-col">
        <label for="jobLocation">Job Location</label>
        <select class="ht-42" v-model.trim="jobLocation.val" id="jobLocation">
          <option value="">Select Location</option>
          <option value="Abu Dhabi">Abu Dhabi</option>
          <option value="Dubai">Dubai</option>
          <option value="Sharjah">Sharjah</option>
          <option value="Ajman">Ajman</option>
          <option value="Umm Al Quwain">Umm Al Quwain</option>
          <option value="Ras Al Khaimah">Ras Al Khaimah</option>
          <option value="Fujairah">Fujairah</option>
          <option value="Al Ain">Al Ain</option>
        </select>
      </div>
      <div class="flex flex-col">
        <label for="workingHours">Working Hours</label>
        <input type="text" id="workingHours" v-model.trim="workingHours.val" placeholder="" />
      </div>
      <div class="flex flex-col">
        <label for="contractType">Contract Type</label>
        <select class="ht-42" v-model.trim="contractType.val" id="contractType">
          <option value="">Select Contract Type</option>
          <option value="Permanent">Permanent</option>
          <option value="Temporary">Temporary</option>
        </select>
      </div>
    </div>
    <div class="mt-6 grid grid-cols-2 gap-6">
      <div class="flex flex-col" :class="{ invalid: !jobDescription.isValid }">
        <label for="jobDescription">Job Description</label>
        <div class="h-32 rounded-lg">
          <textarea id="jobDescription" v-model.trim="jobDescription.val" @blur="clearValidity('jobDescription')"
            placeholder=""
            class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
        </div>
        <transition name="fade" mode="out-in">
          <p v-if="!jobDescription.isValid" class="h-4 text-xs text-red-600">
            {{ jobDescription.msg }}
          </p>
        </transition>
      </div>
      <div class="flex flex-col" :class="{ invalid: !specialInstructions.isValid }">
        <label for="specialInstructions">Special Instructions</label>
        <div class="h-32 rounded-lg">
          <textarea id="specialInstructions" v-model.trim="specialInstructions.val"
            @blur="clearValidity('specialInstructions')" placeholder=""
            class="bg-white resize-none w-full h-full outline-none text-sm border p-4 rounded-lg"></textarea>
        </div>
        <transition name="fade" mode="out-in">
          <p v-if="!specialInstructions.isValid" class="h-4 text-xs text-red-600">
            {{ specialInstructions.msg }}
          </p>
        </transition>
      </div>
    </div>

    <div class="flex flex-col mt-6 border p-6">
      <h2 class="text-lg font-semibold text-gray-800">Target Audience</h2>
      <div class="mt-6 grid grid-cols-3 gap-6">
        <div class="flex flex-col" :class="{ invalid: !entity.isValid }">
          <label for="entity">Entity*</label>
          <select class="ht-42" v-model.trim="entity.val" id="entity" @blur="clearValidity('entity')"
            @change="onEntityChange">
            <option value="">Select an Entity</option>
            <option v-for="(e, index) in entities" :key="index" :value="e">
              {{ getEntityName(e) }}
            </option>
          </select>
          <transition name="fade" mode="out-in">
            <p v-if="!entity.isValid" class="h-4 text-xs text-red-600">
              {{ entity.msg }}
            </p>
          </transition>
        </div>
        <div class="flex flex-col">
          <label for="campus">Campus</label>
          <multiselect v-model.trim="campus.val" :options="campusList" track-by="campus_code"
            :custom-label="customLabelForCampus" placeholder="Select Campus" :multiple="true">
          </multiselect>
        </div>
        <div class="flex flex-col">
          <label for="studentStatus">Student Status*</label>
          <select class="ht-42" v-model.trim="studentStatus.val" id="studentStatus" @change="onStudentStatusChange">
            <option value="Active Students">Active Students</option>
          </select>
        </div>
        <div class="flex flex-col">
          <label for="yearOfStudy">{{ yearOfStudyLabel }}</label>
          <multiselect v-model="yearOfStudy.val" :options="yearOfStudyOptions" :placeholder="yearOfStudyPlaceholder"
            :multiple="true">
          </multiselect>
        </div>
        <div class="flex flex-col">
          <label for="program">Program*</label>
          <select class="ht-42" v-model.trim="program.val" id="program">
            <option value="">All</option>
            <option :value="item" v-for="(item, index) in programsList" :key="index">{{ item }}</option>
          </select>
        </div>
        <div class="flex flex-col" :class="{ invalid: !jobFor.isValid }">
          <label for="jobFor">Nationality*</label>
          <select class="ht-42" v-model.trim="jobFor.val" id="jobFor" @blur="clearValidity('jobFor')">
            <option value="">Select an option</option>
            <option value="1">Local</option>
            <option value="2">Non Local</option>
            <option value="3">Both Local and Non Local</option>
          </select>
          <transition name="fade" mode="out-in">
            <p v-if="!jobFor.isValid" class="h-4 text-xs text-red-600">
              {{ jobFor.msg }}
            </p>
          </transition>
        </div>
        <div class="flex flex-col">
          <label for="gender">Gender*</label>
          <select class="ht-42" v-model.trim="gender.val" id="gender">
            <option value="">Both Male & Female</option>
            <option value="M">Male</option>
            <option value="F">Female</option>
          </select>
        </div>
      </div>
    </div>


    <div class="w-full flex justify-around mt-8 pb-8">
      <div @click.stop="submitForm(false)"
        class="w-36 border-2 border-green-600 px-4 py-2 rounded-lg flex items-center justify-center cursor-pointer bg-green-600 hover:bg-white text-white hover:text-green-600 font-medium">
        Save & Exit</div>
      <div @click.stop="submitForm(true)"
        class="w-36 border-2 border-ternary px-4 py-2 rounded-lg flex items-center justify-center cursor-pointer bg-ternary hover:bg-white text-white hover:text-ternary font-medium">
        {{ getBtnText }}
      </div>
    </div>
    <div class="h-full flex justify-center items-center" v-if="isLoading">
      <base-page-spinner type="spin" class-list="h-20"></base-page-spinner>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.css';
export default {
  name: 'sponsorship-opportunity-form',
  components: {
    Multiselect,
  },
  emits: ['created', 'updated', 'close'],
  props: ['mode', 'selectedItem', 'partnersList', 'nonRegisteredEmployersList'],
  data() {
    return {
      opportunityType: {
        val: 'Sponsorship',
        isValid: true,
        msg: ''
      },
      employerType: {
        val: 'registered',
        isValid: true,
        msg: ''
      },
      selectedEmployer: {
        val: null,
        isValid: true,
        msg: ''
      },
      nonRegisteredEmployer: {
        val: null,
        isValid: true,
        msg: ''
      },
      nonRegisteredEmployerOther: "",
      jobTitle: {
        val: '',
        isValid: true,
        msg: ''
      },
      positionName: {
        val: '',
        isValid: true,
        msg: ''
      },
      gradeNumber: {
        val: '',
        isValid: true,
        msg: ''
      },
      positionNumber: {
        val: '',
        isValid: true,
        msg: ''
      },
      jobDescription: {
        val: '',
        isValid: true,
        msg: ''
      },
      minimumQualification: {
        val: '',
        isValid: true,
        msg: ''
      },
      preferredQualification: {
        val: '',
        isValid: true,
        msg: ''
      },
      expectedSkills: {
        val: '',
        isValid: true,
        msg: ''
      },
      specialInstructions: {
        val: '',
        isValid: true,
        msg: ''
      },
      division: {
        val: '',
        isValid: true,
        msg: ''
      },
      department: {
        val: '',
        isValid: true,
        msg: ''
      },
      jobStartDate: {
        val: this.getCurrentDate(),
        isValid: true,
        msg: ''
      },
      jobCloseDate: {
        val: '',
        isValid: true,
        msg: ''
      },
      jobCategory: {
        val: '',
        isValid: true,
        msg: ''
      },
      salary: {
        val: '',
        isValid: true,
        msg: ''
      },
      vacancy: {
        val: '',
        isValid: true,
        msg: ''
      },
      benefits: {
        val: '',
        isValid: true,
        msg: ''
      },
      jobLocation: {
        val: '',
        isValid: true,
        msg: ''
      },
      workingHours: {
        val: '',
        isValid: true,
        msg: ''
      },
      contractType: {
        val: '',
        isValid: true,
        msg: ''
      },
      jobFor: {
        val: '',
        isValid: true,
        msg: ''
      },
      entity: {
        val: '',
        isValid: true,
        msg: ''
      },
      gender: {
        val: '',
        isValid: true,
        msg: ''
      },
      studentStatus: {
        val: 'Active Students',
        isValid: true,
        msg: ''
      },
      program: {
        val: '',
        isValid: true,
        msg: ''
      },
      campus: {
        val: [],
        isValid: true,
        msg: ''
      },
      yearOfStudy: {
        val: [],
        isValid: true,
        msg: ''
      },
      campusList: [],
      programsList: [],
      formIsValid: true,
      isLoading: false,
      error: null,
      approvedCount: null,
      employersEntityList: [],
    };
  },
  created() {
    if (this.mode == 'edit') {
      this.setFormData();
    }
  },
  watch: {
    'selectedEmployer.val': function (newVal) {
      this.employersEntityList = [];
      if (newVal) {
        this.selectedEmployer.isValid = true;
        this.selectedEmployer.msg = "";
        this.getEmployersEntityList();
      } else {
        this.employersEntityList = ['ADPOLY', 'ATHS', 'FCHS', 'ADVETI'];
      }
    },
    'nonRegisteredEmployer.val': function (newVal) {
      if (newVal) {
        this.nonRegisteredEmployer.isValid = true;
        this.nonRegisteredEmployer.msg = "";
        if (newVal == 'Other') {
          this.nonRegisteredEmployerOther = "";
        }
      }
    },
    'employerType.val': function (newVal) {
      if (this.mode == 'create') {
        this.selectedEmployer = {
          val: null,
          isValid: true,
          msg: ''
        };
        this.nonRegisteredEmployer = {
          val: null,
          isValid: true,
          msg: ''
        };
        if (newVal == 'registered') {
          this.employersEntityList = [];
        } else {
          this.employersEntityList = ['ADPOLY', 'ATHS', 'FCHS', 'ADVETI'];
        }
      }
    },
    'entity.val': function (newVal, oldVal) {
      this.getSpecializations();
      this.getCampusList();
      // Reset year of study when entity changes to avoid invalid selections
      // But only if this is a user-initiated change (not during initial form load)
      // Check if oldVal exists (meaning entity was already set) and student status is Active Students
      if (oldVal && this.studentStatus.val == 'Active Students') {
        // Filter year_of_study to only include values valid for the new entity
        const availableOptions = this.yearOfStudyOptions;
        if (this.yearOfStudy.val && Array.isArray(this.yearOfStudy.val)) {
          this.yearOfStudy.val = this.yearOfStudy.val.filter(val => availableOptions.includes(val));
        } else {
          this.yearOfStudy.val = [];
        }
      }
    },
    'studentStatus.val': function () {
      this.getSpecializations();
    },
  },
  computed: {
    getBtnText() {
      if (this.mode == 'create') {
        return 'Create & Post';
      } else {
        return 'Update & Post';
      }
    },
    yearOfStudyLabel() {
      if (this.entity.val == 'ATHS') {
        return 'Grade';
      }
      return 'Year of Study';
    },
    yearOfStudyOptions() {
      if (this.entity.val == 'ATHS') {
        return ['6', '7', '8', '9', '10', '12'];
      }
      return ['First Year', 'Second Year', 'Third Year', 'Fourth Year', 'Year Five'];
    },
    yearOfStudyPlaceholder() {
      return 'Select ' + this.yearOfStudyLabel;
    },
    entities() {
      if (this.role == 'partner') {
        if (
          this.$store.getters.entity == 'null' ||
          this.$store.getters.entity == ''
        ) {
          return [];
        } else {
          return this.$store.getters.entity.split(',');
        }
      } else {
        return this.employersEntityList;
      }
    },
    role() {
      return this.$store.getters.role;
    }
  },
  methods: {
    getEntityName(entity) {
      return entity.replace(/ATHS/g, "ATS");
    },
    allowNumbersOnly(event) {
      const charCode = event.which || event.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault();
      }
    },
    clearValidity(input) {
      this[input].isValid = true;
      this[input].msg = '';
    },
    validateForm() {
      this.formIsValid = true;

      if (this.role != 'partner' && this.mode == 'create') {
        if (this.employerType.val == 'registered') {
          if (this.selectedEmployer.val === null) {
            this.selectedEmployer.isValid = false;
            this.selectedEmployer.msg = 'You must select an employer.';
            this.formIsValid = false;
          }
        } else {
          if (this.nonRegisteredEmployer.val === null || (this.nonRegisteredEmployer.val === 'Other' && this.nonRegisteredEmployerOther == '')) {
            this.nonRegisteredEmployer.isValid = false;
            this.nonRegisteredEmployer.msg = 'Employer must not be empty.';
            this.formIsValid = false;
          }
        }
      }
      if (this.jobTitle.val === '') {
        this.jobTitle.isValid = false;
        this.jobTitle.msg = 'Job Title must not be empty.';
        this.formIsValid = false;
      }
      if (this.positionName.val === '') {
        this.positionName.isValid = false;
        this.positionName.msg = 'Position must not be empty.';
        this.formIsValid = false;
      }
      if (this.jobStartDate.val === '') {
        this.jobStartDate.isValid = false;
        this.jobStartDate.msg = 'Job Start Date must not be empty.';
        this.formIsValid = false;
      }
      if (this.jobCloseDate.val === '') {
        this.jobCloseDate.isValid = false;
        this.jobCloseDate.msg = 'Job Close Date must not be empty.';
        this.formIsValid = false;
      }
      if (this.vacancy.val === '') {
        this.vacancy.isValid = false;
        this.vacancy.msg = 'Vacancy must not be empty.';
        this.formIsValid = false;
      }
      if (this.jobFor.val === '') {
        this.jobFor.isValid = false;
        this.jobFor.msg = 'You must select an option.';
        this.formIsValid = false;
      }
      if (this.entity.val === '') {
        this.entity.isValid = false;
        this.entity.msg = 'You must select an Entity.';
        this.formIsValid = false;
      }
    },
    async submitForm(isPosted = false) {
      this.validateForm();

      if (!this.formIsValid) {
        return;
      }

      let employerName = '';
      if (this.mode == 'create') {
        if (this.employerType.val == 'registered') {
          const partner = this.partnersList.find(partner => partner.id == this.selectedEmployer.val.id);
          if (partner) {
            employerName = partner.en_company_name;
          } else {
            employerName = "";
          }
        } else {
          employerName = this.nonRegisteredEmployer.val == 'Other' ? this.nonRegisteredEmployerOther : this.nonRegisteredEmployer.val;
        }
      }

      const campusArray = this.campus.val && Array.isArray(this.campus.val)
        ? this.campus.val.map(c => c.campus_code)
        : [];

      const yearOfStudyArray = this.yearOfStudy.val && Array.isArray(this.yearOfStudy.val)
        ? this.yearOfStudy.val
        : [];

      const formData = {
        opportunity_type: this.opportunityType.val,
        employer_type: this.employerType.val,
        selected_employer: this.selectedEmployer.val ? parseInt(this.selectedEmployer.val.id) : null,
        employer_name: employerName,
        job_title: this.jobTitle.val,
        grade_number: this.gradeNumber.val,
        position_name: this.positionName.val,
        position_number: parseInt(this.positionNumber.val),
        job_description: this.jobDescription.val,
        minimum_qualification: this.minimumQualification.val,
        preferred_qualification: this.preferredQualification.val,
        expected_skills: this.expectedSkills.val,
        special_instructions: this.specialInstructions.val,
        division: this.division.val,
        department: this.department.val,
        job_start_date: this.jobStartDate.val,
        job_close_date: this.jobCloseDate.val,
        job_category: this.jobCategory.val,
        salary: this.salary.val,
        benefits: this.benefits.val,
        job_location: this.jobLocation.val,
        contract_type: this.contractType.val,
        job_for: this.jobFor.val,
        gender: this.gender.val,
        entity: this.entity.val,
        campus: campusArray.length > 0 ? campusArray : null,
        student_status: this.studentStatus.val,
        year_of_study: yearOfStudyArray.length > 0 ? yearOfStudyArray : null,
        program: this.program.val,
        working_hours: this.workingHours.val,
        vacancy: parseInt(this.vacancy.val),
        is_posted: isPosted
      };

      const CREATE_MUTATION = gql`
          mutation CreateJob($input: CreateJobInput!) {
            createJob(input: $input) {
              error
              message
            }
          }
        `;

      const UPDATE_MUTATION = gql`
          mutation UpdateJob($id: ID!, $input: CreateJobInput!) {
            updateJob(id: $id, input: $input) {
              error
              message
            }
          }
        `;

      this.isLoading = true;

      try {
        await this.$apollo
          .mutate({
            mutation:
              this.mode == 'create' ? CREATE_MUTATION : UPDATE_MUTATION,
            variables: {
              id: this.mode == 'edit' ? this.selectedItem.id : null,
              input: formData
            }
          })
          .then(data => {
            if (this.mode == 'create') {
              if (data.data.createJob.error) {
                this.error = data.data.createJob.message;
              }
            } else {
              if (data.data.updateJob.error) {
                this.error = data.data.updateJob.message;
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
        this.error = error.message || 'Failed to authenticate, try later.';
      }

      if (this.error === null) {
        if (this.mode == 'create') {
          this.$emit('created');
        } else {
          this.$emit('updated');
        }
      } else {
        this.$swal
          .fire({
            icon: 'error',
            title: 'Oops...',
            text: this.error
          })
          .then(result => {
            if (result.value || result.dismiss) {
              this.$emit('close');
            }
          });
      }

      this.isLoading = false;
    },
    setFormData() {
      let selectedEmployer = null;
      if (this.selectedItem.partner) {
        selectedEmployer = {
          "__typename": "Partner",
          "id": this.selectedItem.partner.id,
          "en_company_name": this.selectedItem.partner.en_company_name
        };
      } else {
        this.employersEntityList = ['ADPOLY', 'ATHS', 'FCHS', 'ADVETI'];
      }
      this.opportunityType.val = this.selectedItem.opportunity_type || 'Sponsorship';
      this.employerType.val = this.selectedItem.employer_type;
      this.selectedEmployer.val = selectedEmployer;
      this.jobTitle.val = this.selectedItem.job_title;
      this.gradeNumber.val = this.selectedItem.grade_number;
      this.positionName.val = this.selectedItem.position_name;
      this.positionNumber.val = this.selectedItem.position_number;
      this.jobDescription.val = this.selectedItem.job_description;
      this.minimumQualification.val = this.selectedItem.minimum_qualification;
      this.preferredQualification.val = this.selectedItem.preferred_qualification;
      this.expectedSkills.val = this.selectedItem.expected_skills;
      this.specialInstructions.val = this.selectedItem.special_instructions;
      this.division.val = this.selectedItem.division;
      this.department.val = this.selectedItem.department;
      this.jobStartDate.val = this.selectedItem.job_close_date
        ? this.selectedItem.job_start_date
        : this.getCurrentDate();
      this.jobCloseDate.val = this.selectedItem.job_close_date
        ? this.selectedItem.job_close_date
        : '';
      this.jobCategory.val = this.selectedItem.job_category;
      this.salary.val = this.selectedItem.salary;
      this.benefits.val = this.selectedItem.benefits;
      this.jobLocation.val = this.selectedItem.job_location
        ? this.selectedItem.job_location
        : '';
      this.contractType.val = this.selectedItem.contract_type
        ? this.selectedItem.contract_type
        : '';
      this.jobFor.val = this.selectedItem.job_for
        ? this.selectedItem.job_for
        : '';
      this.studentStatus.val = this.selectedItem.student_status
        ? this.selectedItem.student_status
        : '';
      this.program.val = this.selectedItem.program
        ? this.selectedItem.program
        : '';
      this.gender.val = this.selectedItem.gender
        ? this.selectedItem.gender
        : '';
      this.entity.val = this.selectedItem.entity
        ? this.selectedItem.entity
        : '';
      // Store campus codes temporarily - will be synced with campus list when loaded
      if (this.selectedItem.campus && Array.isArray(this.selectedItem.campus) && this.selectedItem.campus.length > 0) {
        this.campus.val = this.selectedItem.campus.map(c => {
          if (typeof c === 'string') {
            return { campus_code: c };
          }
          return c;
        });
      } else {
        this.campus.val = [];
      }
      // Set year of study - filter to only include values that exist in current options
      // Entity is already set above, so yearOfStudyOptions computed property should be ready
      // Use $nextTick to ensure all watchers have run and computed properties are stable
      this.$nextTick(() => {
        if (this.selectedItem.year_of_study && Array.isArray(this.selectedItem.year_of_study) && this.selectedItem.year_of_study.length > 0) {
          const availableOptions = this.yearOfStudyOptions;
          // Filter to only include values that exist in the current options (based on entity)
          this.yearOfStudy.val = this.selectedItem.year_of_study.filter(val => availableOptions.includes(val));
        } else {
          this.yearOfStudy.val = [];
        }
      });
      this.workingHours.val = this.selectedItem.working_hours;
      this.vacancy.val = this.selectedItem.vacancy
        ? parseInt(this.selectedItem.vacancy)
        : '';
      this.approvedCount = this.selectedItem.approved_count;
      // Load campus list if needed (async, will sync selected campuses after loading)
      if (this.entity.val) {
        this.getCampusList();
      }
      // Load specializations if entity and student status are set
      if (this.entity.val && this.studentStatus.val) {
        this.getSpecializations();
      }
    },
    getCurrentDate() {
      const today = new Date();
      const year = today.getFullYear();
      let month = (today.getMonth() + 1).toString().padStart(2, '0');
      let day = today
        .getDate()
        .toString()
        .padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    async getEmployersEntityList() {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
              query GetEmployersEntityList($partner_id: Int!) {
                getEmployersEntityList(partner_id: $partner_id)
              }
            `,
          variables: {
            partner_id: parseInt(this.selectedEmployer.val.id)
          },
          fetchPolicy: 'network-only'
        });
        this.employersEntityList = data.getEmployersEntityList;
      } catch (error) {
        console.log(error);
      }
    },
    async getSpecializations() {
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query GetSpecializations(
              $student_status: String
              $entity: String
            ) {
              getSpecializations(
                student_status: $student_status
                entity: $entity
              )
            }
          `,
          variables: {
            entity: this.entity.val,
            student_status: this.studentStatus.val == 'Alumni' ? 'IG' : (this.studentStatus.val == 'Senior Students' ? 'AS' : ''),
          },
        });
        this.programsList = data.getSpecializations;
      } catch (error) {
        console.log(error);
      }
    },
    customLabelForRegisteredEmployer(option) {
      return option.en_company_name;
    },
    async getCampusList() {
      if (!this.entity.val) {
        this.campusList = [];
        return;
      }
      try {
        const { data } = await this.$apollo.query({
          query: gql`
            query GetCampusList($student_status: String, $entity: String) {
              getCampusList(student_status: $student_status, entity: $entity) {
                entity
                campus_code
              }
            }
          `,
          variables: {
            student_status: '',
            entity: this.entity.val,
          },
          fetchPolicy: 'network-only'
        });
        this.campusList = data.getCampusList;

        // If we have selected campuses (from edit mode), sync them with the loaded list
        if (this.campus.val && this.campus.val.length > 0) {
          const selectedCodes = this.campus.val.map(c => typeof c === 'string' ? c : c.campus_code);
          this.campus.val = this.campusList.filter(c => selectedCodes.includes(c.campus_code));
        }
      } catch (error) {
        console.log(error);
        this.campusList = [];
      }
    },
    onEntityChange() {
      this.getCampusList();
    },
    onStudentStatusChange() {
      if (this.studentStatus.val != 'Active Students') {
        this.yearOfStudy.val = [];
      }
    },
    customLabelForCampus(option) {
      return option.campus_code;
    },
  }
};
</script>

<style lang="scss" scoped>
label {
  @apply mb-1 block text-sm;
}

input[type='text'],
input[type='email'],
input[type='number'],
input[type='password'],
input[type='date'],
select {
  @apply block w-full border rounded-lg py-2 px-2;
}

input[type='text']:focus,
input[type='email']:focus,
input[type='number']:focus,
input[type='password']:focus,
input[type='date']:focus,
select:focus {
  outline: none;
  border-color: #394867;
  box-shadow: 0 0 0 2px #394867;
}

.invalid label {
  @apply text-red-600;
}

.invalid input,
.invalid select {
  border: 1px solid red;
}

input[type='checkbox'] {
  @apply w-auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  height: 0px;
}

.ht-42 {
  height: 42px;
}
</style>
